<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a *ngIf="userType != 12" class="logo" href="javascript:void(0)" (click)="navigateHome()"> Budget Management System </a>
    <a *ngIf="userType === 12" class="logo" href="javascript:void(0)" (click)="navigateAuxiliary()"> Auxiliary Budget Expenses </a>
  </div>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
</div>

<div class="header-container">
  <nb-actions size="small">
    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action> -->
    <!-- <nb-action class="control-item" icon="email-outline"></nb-action> -->

    <nb-action class="control-item">
      <input *ngIf="userType != 1 && userType != 11" type="text" class="form-control" [value]="getCampusName(currentCampus)" readonly />
      <nb-select *ngIf="userType === 1" [(ngModel)]="currentCampus" (selectedChange)="changeCampus()">
        <nb-option *ngFor="let campus of campuses" [value]="campus.value"> {{ campus.text }} </nb-option>
      </nb-select>
    </nb-action>

    <!-- <nb-action class="control-item" icon="bell-outline"></nb-action> -->

    <!-- <nb-action class="user-action" *nbIsGranted="['view', 'user']"> -->
    <nb-action *ngIf="userMenu.length>0" class="user-action">
      <nb-user [nbContextMenu]="userMenu"
        [onlyPicture]="userPictureOnly"
        [name]="user?.name"
        [picture]="user?.picture">
        <!-- <nb-user [nbContextMenu]="userMenu"
        [onlyPicture]="userPictureOnly"
        [name]="user?.name"> -->
      </nb-user>
    </nb-action>
  </nb-actions>
</div>